const Contact = () => {
  return (
    <section id="contact" className="section">

      <h2>📞 Contact Us</h2>

      <div className="contact-grid">
        {/* Contact Details */}
        <div className="contact-box">
          <h3>New Aryaveer Senior Secondary School</h3>
          <p>
            <strong>📍 Address:</strong><br />
            Tal, District Ratlam,<br />
            Madhya Pradesh – 457118
          </p>

          <p>
            <strong>📞 Phone:</strong><br />
            +91 9893741102
          </p>

          <p>
            <strong>📧 Email:</strong><br />
            aryaveeracademy912@gmail.com
          </p>
        </div>

        {/* Google Map */}
        <div className="contact-box">
          <iframe
            title="School Location"
            src="https://www.google.com/maps?q=New%20Aryaveer%20Senior%20Secondary%20School%20Tal%20Ratlam&output=embed"
            width="100%"
            height="300"
            style={{ border: 0, borderRadius: "12px" }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default Contact;
